/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UiIdentifier
 */
export interface UiIdentifier {
    /**
     * 
     * @type {string}
     * @memberof UiIdentifier
     */
    uiType?: string;
    /**
     * 
     * @type {number}
     * @memberof UiIdentifier
     */
    uiIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof UiIdentifier
     */
    ui?: string;
    /**
     * 
     * @type {string}
     * @memberof UiIdentifier
     */
    db?: string;
}

/**
 * Check if a given object implements the UiIdentifier interface.
 */
export function instanceOfUiIdentifier(value: object): value is UiIdentifier {
    return true;
}

export function UiIdentifierFromJSON(json: any): UiIdentifier {
    return UiIdentifierFromJSONTyped(json, false);
}

export function UiIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): UiIdentifier {
    if (json == null) {
        return json;
    }
    return {
        
        'uiType': json['uiType'] == null ? undefined : json['uiType'],
        'uiIndex': json['uiIndex'] == null ? undefined : json['uiIndex'],
        'ui': json['ui'] == null ? undefined : json['ui'],
        'db': json['db'] == null ? undefined : json['db'],
    };
}

export function UiIdentifierToJSON(json: any): UiIdentifier {
    return UiIdentifierToJSONTyped(json, false);
}

export function UiIdentifierToJSONTyped(value?: UiIdentifier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uiType': value['uiType'],
        'uiIndex': value['uiIndex'],
        'ui': value['ui'],
        'db': value['db'],
    };
}

